import EnvironmentManager from 'Utils/environmentManager';


export const isSporTotoV2Enabled = () => {
  return EnvironmentManager.getMessageText({ key: 'sportoto_v2_api' }) === 'true';
};

export const encodeSporTotoRequest = data =>
  btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(data))));
